import React, { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";

import { createCourse } from "../../actions/course";

import AddAttachment from "../layout/Mentors/AddAttachment";
import VolumeRed from "../layout/Mentors/VolumeRed";

import { evaluate } from "../../utilities/props";

import LoggedInNavRed from "../layout/IME/LoggedInNavRed";

const CreateCourse = ({
  auth: { user },
  isAuthenticated,
  course: { course },
  time,
  videoduration,
  createCourse,
}) => {
  const [file, setFile] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [coursePosterFile, setCoursePosterFile] = useState("");
  const [coursePoster, setCoursePoster] = useState("");
  const [attachmentFile, setAttachmentFile] = useState({
    file: "",
    description: "",
  });
  const [attachmentDataFile, setAttachmentDataFile] = useState("");
  const [coursetitle, setCourseTitle] = useState("");
  const [coursedescription, setCourseDescription] = useState("");
  const [purchasermessage, setPurchaserMessage] = useState("");
  const [section, setSection] = useState({
    sectionName: "",
    sectionVideos: [],
  });
  const [courseVideo, setCourseVideo] = useState({
    videoname: "",
    video: "",
    poster: "",
    posterImage: "",
  });
  const [sections, setSections] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [files, setFiles] = useState([]);
  const [view, setView] = useState({
    course: true,
    video: false,
  });
  time = evaluate(time);
  videoduration = evaluate(videoduration);
  const videoRef = useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [showOverlay, setshowOverlay] = useState(true);
  const [addAttachment, setShowAddAttachment] = useState(false);
  const [SectionName, setSectionName] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateDuration = () => {
      setDuration(video.duration);
    };
    video.addEventListener("loadedmetadata", updateDuration);

    return () => video.removeEventListener("loadedmetadata", updateDuration);
  }, [setDuration]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const updateTime = () => {
      setCurrentTime(video.currentTime);
    };
    video.addEventListener("timeupdate", updateTime);
    return () => video.removeEventListener("timeupdate", updateTime);
  }, [currentTime, setCurrentTime]);

  if (course && course.msg === "Course Successfully Submitted") {
    return <Redirect to={`/${user.channelid}/content`} />;
  }

  if (!isAuthenticated) {
    return <Redirect to="/" />;
  } else if (isAuthenticated && user && user.channelid !== "roland") {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      {addAttachment && (
        <AddAttachment
          setShowAddAttachment={setShowAddAttachment}
          setAttachmentFile={setAttachmentFile}
          attachmentFile={attachmentFile}
          setAttachmentDataFile={setAttachmentDataFile}
          attachmentDataFile={attachmentDataFile}
          setAttachments={setAttachments}
          attachments={attachments}
          setFiles={setFiles}
          files={files}
        />
      )}
      <LoggedInNavRed />
      <div className="flex-only-even-alt">
        <div className="side-container border-right grey">
          <div className="online-title-container-alt">
            <div className="border-alt red">
              <p className="online-title-alt red">
                <i className="fas fa-video red mr-5"></i>Course Content
              </p>
            </div>
          </div>
          {sections.length <= 0 && (
            <div className="empty-side-container">
              <p className="empty-content red">No Content</p>
            </div>
          )}
          <div className="all-content-section">
            {sections.length > 0 &&
              sections.isArray &&
              sections.map((item, index) => {
                return (
                  <div className="section-container" key={index} index={index}>
                    <p className="section-title-alt red">{item.sectionName}</p>
                    <button
                      className="section-button background-red"
                      onClick={() => {
                        sections.splice(index, 1);
                        setSections([...sections]);
                      }}
                    >
                      <i className="fas fa-times mx-5"></i>Delete Section
                    </button>
                    {item.sectionVideos.map((result, index) => {
                      return (
                        <div
                          className="course-video-content-container"
                          key={index}
                        >
                          <div className="video-icon-container">
                            <ol className="course-videos">
                              <img
                                src={result.posterImage}
                                alt="poster"
                                className="video-poster "
                              />
                              <li className="course-video">
                                {result.videoname}
                              </li>
                              {/* <button className="course-button background-black">
                                <i className="fas fa-edit mx-5"></i>Edit
                              </button> */}
                            </ol>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                );
              })}
          </div>
        </div>
        <div className="main-body-media">
          <div className="container-body">
            <div className="active-view">
              <div
                onClick={() => setView({ course: true, video: false })}
                className={
                  view.course
                    ? "section-title red underline"
                    : "section-title red"
                }
              >
                Course Info
                {coursetitle !== "" &&
                  coursedescription !== "" &&
                  coursePoster !== "" && (
                    <i className="far fa-check-circle fa-lg mx-5 red"></i>
                  )}
              </div>
              <div
                onClick={() => setView({ course: false, video: true })}
                className={
                  view.video
                    ? "section-title red underline"
                    : "section-title red"
                }
              >
                Video Info
                {section.sectionName !== "" &&
                  courseVideo.videoname !== "" &&
                  courseVideo.video !== "" && (
                    <i className="far fa-check-circle fa-lg mx-5 red"></i>
                  )}
              </div>
            </div>
            {view.course && (
              <div className="items-container-article">
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p className="sub-section red">*Course Title/Description</p>
                  </div>
                  <div className="input-label-container">
                    <input
                      type="text"
                      name="coursetitle"
                      value={coursetitle}
                      className="input-item"
                      placeholder="Enter course title or description"
                      onChange={(e) => setCourseTitle(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}
            {view.course && (
              <div>
                <div className="sub-section-container-title">
                  <div className="flex-only">
                    <p className="sub-section red">*Course Poster</p>
                  </div>
                </div>
                {coursePosterFile !== "" && (
                  <div
                    className="add-keyword-alt background-red"
                    onClick={() => {
                      setCoursePosterFile("");
                    }}
                  >
                    <i className="fas fa-times fa-sm mx-5"></i>Remove Course
                    Poster
                  </div>
                )}
                <div className="create-article">
                  {coursePosterFile === "" ? (
                    <div className="create-article-container">
                      <label
                        htmlFor="articleImage"
                        className="setup-image-container"
                      >
                        <div className="create-image-icons red">
                          <i className="fas fa-plus fa-lg red"></i>
                          <i className="fas fa-image fa-4x mx-5 red"></i>
                        </div>
                      </label>
                      <input
                        type="file"
                        name="articleImage"
                        id="articleImage"
                        className="file-upload red"
                        onChange={(e) => {
                          setCoursePosterFile(
                            URL.createObjectURL(e.target.files[0])
                          );
                          setCoursePoster(e.target.files[0].name);
                          setFiles([...files, e.target.files[0]]);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="create-article-container">
                      <label
                        htmlFor="articleImage"
                        className="setup-image-container"
                      >
                        <div className="article-media-container">
                          <img
                            className="article-media"
                            src={coursePosterFile}
                          />
                          <input
                            type="file"
                            name="articleImage"
                            id="articleImage"
                            className="file-upload"
                            onChange={(e) => {
                              setCoursePosterFile(
                                URL.createObjectURL(e.target.files[0])
                              );
                              setCoursePoster(e.target.files[0]);
                            }}
                          />
                        </div>
                      </label>
                    </div>
                  )}
                </div>
              </div>
            )}
            {view.video && (
              <div className="items-container-article">
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p className="sub-section red">
                      *Section Title/Description
                    </p>
                  </div>
                  <div className="input-label-container">
                    {!SectionName && (
                      <input
                        type="text"
                        name="sectiontitle"
                        value={section.sectionName}
                        className="input-item"
                        placeholder="Enter section title or description"
                        onChange={(e) =>
                          setSection({
                            ...section,
                            sectionName: e.target.value,
                          })
                        }
                      />
                    )}
                    {section.sectionName !== "" && !SectionName && (
                      <div
                        className="add-keyword-alt background-red"
                        onClick={() => {
                          setSectionName(true);
                        }}
                      >
                        <i className="fas fa-plus fa-sm mx-5"></i>Set Section
                        Title
                      </div>
                    )}
                    {SectionName && (
                      <li className="keywordsArray white">
                        {section.sectionName}
                        <i
                          className="fas fa-times fa-sm white times-sm mx-10"
                          onClick={() => {
                            setSectionName(false);
                          }}
                        ></i>
                      </li>
                    )}
                  </div>
                </div>
              </div>
            )}
            {view.video && (
              <div className="items-container-article">
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p className="sub-section red">*Video Title/Description</p>
                  </div>
                  <div className="input-label-container">
                    <input
                      type="text"
                      name="videotitle"
                      value={courseVideo.videoname}
                      className="input-item"
                      placeholder="Enter video title or description"
                      onChange={(e) =>
                        setCourseVideo({
                          ...courseVideo,
                          videoname: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>
            )}
            {view.video && (
              <div>
                <div className="sub-section-container-title">
                  <div className="flex-only">
                    <p className="sub-section red">*Course Video</p>
                  </div>
                </div>
                {file !== "" && (
                  <div
                    className="add-keyword-alt background-red"
                    onClick={() => {
                      setFile("");
                    }}
                  >
                    <i className="fas fa-times fa-sm mx-5"></i>Remove Video
                  </div>
                )}
                <div className="create-article">
                  {file === "" ? (
                    <div className="create-article-container">
                      <label
                        htmlFor="coursevideo"
                        className="setup-image-container"
                      >
                        <div className="create-image-icons red">
                          <i className="fas fa-plus fa-lg red"></i>
                          <i className="fas fa-video fa-4x mx-5 red"></i>
                        </div>
                      </label>
                      <input
                        type="file"
                        name="coursevideo"
                        id="coursevideo"
                        className="file-upload red"
                        onChange={(e) => {
                          setFile(URL.createObjectURL(e.target.files[0]));
                          setCourseVideo({
                            ...courseVideo,
                            video: e.target.files[0].name,
                          });
                          setFiles([...files, e.target.files[0]]);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="create-article-container">
                      <label
                        htmlFor="coursevideo"
                        className="setup-image-container"
                      >
                        <div className="article-media-container">
                          <div
                            className={
                              showOverlay
                                ? "alt-video-overlay"
                                : "alt-video-overlay-pause"
                            }
                          >
                            <div className="alt-left-controls">
                              <ul className="controls">
                                <VolumeRed
                                  className="Rac__volume"
                                  onChange={(level) => {
                                    const volume = level / 100;
                                    videoRef.current.volume = volume;
                                    videoRef.current.muted = volume === 0;
                                  }}
                                />
                              </ul>
                            </div>
                          </div>
                          <video
                            ref={videoRef}
                            autoPlay={true}
                            className="article-media"
                            src={file}
                          />
                          <input
                            type="file"
                            name="coursevideo"
                            id="coursevideo"
                            className="file-upload"
                            onChange={(e) => {
                              setFile(URL.createObjectURL(e.target.files[0]));
                              setCourseVideo({
                                ...courseVideo,
                                video: e.target.files[0].name,
                              });
                              setFiles([...files, e.target.files[0]]);
                            }}
                          />
                        </div>
                      </label>
                    </div>
                  )}
                </div>
              </div>
            )}
            {view.video && (
              <div>
                <div className="sub-section-container-title">
                  <div className="flex-only">
                    <p className="sub-section red">*Video Poster</p>
                  </div>
                </div>
                {imageFile !== "" && (
                  <div
                    className="add-keyword-alt background-red"
                    onClick={() => {
                      setImageFile("");
                    }}
                  >
                    <i className="fas fa-times fa-sm mx-5"></i>Remove Poster
                  </div>
                )}
                <div className="create-article">
                  {imageFile === "" ? (
                    <div className="create-article-container">
                      <label
                        htmlFor="articleImage"
                        className="setup-image-container"
                      >
                        <div className="create-image-icons red">
                          <i className="fas fa-plus fa-lg red"></i>
                          <i className="fas fa-image fa-4x mx-5 red"></i>
                        </div>
                      </label>
                      <input
                        type="file"
                        name="articleImage"
                        id="articleImage"
                        className="file-upload red"
                        onChange={(e) => {
                          setImageFile(URL.createObjectURL(e.target.files[0]));
                          setCourseVideo({
                            ...courseVideo,
                            poster: e.target.files[0].name,
                            posterImage: URL.createObjectURL(e.target.files[0]),
                          });
                          setFiles([...files, e.target.files[0]]);
                        }}
                      />
                    </div>
                  ) : (
                    <div className="create-article-container">
                      <label
                        htmlFor="articleImage"
                        className="setup-image-container"
                      >
                        <div className="article-media-container">
                          <img className="article-media" src={imageFile} />
                          <input
                            type="file"
                            name="articleImage"
                            id="articleImage"
                            className="file-upload"
                            onChange={(e) => {
                              setImageFile(
                                URL.createObjectURL(e.target.files[0])
                              );
                              setCourseVideo({
                                ...courseVideo,
                                poster: e.target.files[0].name,
                                posterImage: URL.createObjectURL(
                                  e.target.files[0]
                                ),
                              });
                              setFiles([...files, e.target.files[0]]);
                            }}
                          />
                        </div>
                      </label>
                    </div>
                  )}
                </div>
              </div>
            )}
            {view.course && (
              <div className="items-container-article">
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p className="sub-section red">*Course Info/Description</p>
                  </div>
                  <div className="input-label-container">
                    <textarea
                      className="edit-summary"
                      placeholder="Enter course info/description"
                      value={coursedescription}
                      onChange={(e) => setCourseDescription(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              </div>
            )}
            {view.course && (
              <div className="items-container-article">
                <div className="sub-section-container-alt">
                  <div className="flex-only">
                    <p className="sub-section red">Message to Purchaser</p>
                  </div>
                  <div className="input-label-container">
                    <textarea
                      className="edit-summary"
                      placeholder="Enter message to purchaser"
                      value={purchasermessage}
                      onChange={(e) => setPurchaserMessage(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              </div>
            )}
          </div>
          {view.video && (
            <div className="side-container border-left border-right grey">
              <div className="container-name red">
                {section.sectionName !== "" ? (
                  <p className="container-title">
                    {section.sectionName}
                    <i className="far fa-check-circle fa-sm mx-5 red"></i>
                  </p>
                ) : (
                  <p className="container-title">No Section Name</p>
                )}
              </div>
              {section.sectionVideos.isArray &&
                section.sectionVideos.length <= 0 && (
                  <div className="empty-side-container">
                    <p className="empty-content red">No Content</p>
                  </div>
                )}
              <div className="all-content-section">
                {section.sectionVideos.isArray &&
                  section.sectionVideos.length > 0 &&
                  section.sectionVideos.map((pendingVideo, index) => {
                    return (
                      <div
                        className="section-container"
                        key={index}
                        index={index}
                      >
                        <div className="course-video-content-container">
                          <div className="video-icon-container">
                            <ol className="course-videos">
                              <div className="course-video-poster">
                                <img
                                  src={pendingVideo.posterImage}
                                  alt="poster"
                                  className="video-poster "
                                />
                              </div>
                              <li className="course-video">
                                {pendingVideo.videoname}
                              </li>
                              {/* <button className="course-button background-black">
                                <i className="fas fa-edit mx-5"></i>Edit
                              </button> */}
                              <button
                                className="course-button-alt background-red"
                                onClick={() => {
                                  section.sectionVideos.splice(index, 1);
                                  setSection({
                                    ...section,
                                    sectionVideos: [...section.sectionVideos],
                                  });
                                }}
                              >
                                <i className="fas fa-times mx-5"></i>Delete
                                Video
                              </button>
                            </ol>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
        <div className="side-container border-left grey">
          <div className="online-title-container-alt">
            <div className="border-alt red">
              <p className="online-title-alt red">
                <i className="fas fa-paperclip red mr-5"></i>Course Attachments
              </p>
            </div>
          </div>
          <div
            className="new-section bold red"
            onClick={() => setShowAddAttachment(true)}
          >
            <i className="fas fa-paperclip fa-lg red mx-5"></i>New Attachment
          </div>
          {attachments && attachments.isArray && attachments.length <= 0 && (
            <div className="empty-side-container">
              <p className="empty-content red">No Attachments</p>
            </div>
          )}
          <div className="all-content-section">
            {attachments &&
              attachments.isArray &&
              attachments.map((item, index) => {
                return (
                  <div className="section-container primary" key={index}>
                    <p className="attachment-name">
                      <i className="far fa-folder fa-lg mr-10 red"></i>
                      {item.file}
                    </p>
                    <div className="attachment-info">
                      <p className="attachment-text">{item.description}</p>
                    </div>
                    <button
                      className="course-button-alt-two background-red"
                      onClick={() => {
                        attachments.splice(index, 1);
                        setAttachments([...attachments]);
                      }}
                    >
                      <i className="fas fa-times mx-5"></i>Delete Attachment
                    </button>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      {section.sectionName !== "" &&
        courseVideo.videoname !== "" &&
        file !== "" &&
        imageFile !== "" && (
          <div className="submit-changes-alt">
            <button
              className="submit-changes-button background-red"
              onClick={() => {
                setSection({
                  ...section,
                  sectionVideos: [...section.sectionVideos, courseVideo],
                });
                setCourseVideo({
                  videoname: "",
                  video: "",
                  poster: "",
                  posterImage: "",
                });
                setFile("");
                setImageFile("");
              }}
            >
              Add Video to Section
            </button>
          </div>
        )}
      {section.sectionVideos.isArray &&
        section.sectionVideos.length > 0 &&
        section.sectionName !== "" &&
        section.sectionName !== "" &&
        courseVideo.videoname === "" &&
        file === "" &&
        imageFile === "" &&
        SectionName && (
          <div className="submit-changes-alt">
            <button
              className="submit-changes-button background-red"
              onClick={() => {
                setSections([...sections, section]);
                setSection({
                  ...section,
                  sectionName: "",
                  sectionVideos: [],
                });
                setSectionName(false);
              }}
            >
              Create New Section
            </button>
          </div>
        )}
      {coursetitle !== "" &&
        coursePoster !== "" &&
        coursedescription !== "" &&
        sections.length > 0 &&
        !addAttachment &&
        section.sectionName === "" &&
        courseVideo.videoname === "" &&
        courseVideo.video === "" &&
        courseVideo.poster === "" && (
          <div className="submit-changes">
            <button
              className="submit-changes-button background-red"
              onClick={() =>
                createCourse(
                  coursetitle,
                  coursedescription,
                  coursePoster,
                  purchasermessage,
                  sections,
                  attachments,
                  files
                )
              }
            >
              Submit Course
            </button>
          </div>
        )}
    </Fragment>
  );
};

CreateCourse.propTypes = {
  auth: PropTypes.object.isRequired,
  course: PropTypes.object.isRequired,
  createCourse: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  course: state.course,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { createCourse })(CreateCourse);
